//bao migrate skip
import * as ko from "knockout";
import BaoMenu from "./../../services/bao-menu";
import BaoDialog from "./../../factories/bao-dialog";
import Bao from "./../../services/bao-service";
import baoRouter from "./../../services/bao-router";
import AppTabController from "./../../services/app-tab-controller";
import "./../bindings/checklist";
function EvaluationViewModel(tabPage) {
    var self = this;
    var _deleteEvaluationMessage = Bao.Session.GetMessage("msgDeleteEvaluation");
    self.TabPage = tabPage;
    self.TabPage.TabSelected = function () {
        self.CalculateWidth();
    };
    self.CalculateWidth = function () { };
    self.ChecklistModel = {};
    self.iFrame = {};
    self.TabName = ko.observable();
    self.ChecklistId = ko.observable();
    self.EvaluationId = ko.observable();
    self.UrlData = ko.observable();
    self.Url = ko.observable();
    self.IsCompleted = ko.observable(false);
    self.HasEditPermissionForFolderStructure = ko.observable(true);
    self.TabName.subscribe(function () {
        tabPage.Title(self.TabName());
    });
    self.EvaluationId.subscribe(function () {
        tabPage.ObjectId(self.EvaluationId());
    });
    self.Save = function () {
        if (tabPage.UrlData().IsNew == true) {
            tabPage.UrlData().IsNew = false;
        }
        if (self.ChecklistModel) {
            return self.ChecklistModel.Save().done(function (data) {
                Bao.raiseEvent("checklist-evaluation:refresh", null);
            });
        } else {
            return $.Deferred().resolve();
        }

    };
    self.IsCompleted.subscribe(function () {
        self.SetDeleteAndSavePermission();
    });
    self.DeleteDate = ko.observable();
    self.DeleteDate.subscribe(function () {
        self.SetDeleteAndSavePermission();
    });
    self.SetDeleteAndSavePermission = function () {
        // Speichern erlaubt / Save enabled?
        BaoMenu.permissionEnable({
            ActionKey: "EvaluationSave",
            Enabled: self.HasEditPermissionForFolderStructure(),
            Context: tabPage.Context()
        });

        // Delete enabled?
        if (self.DeleteDate() != null) {
            BaoMenu.permissionEnable({
                ActionKey: "ChecklistEvaluationDeleteIncomplete",
                Enabled: false,
                Context: tabPage.Context()
            });
        }
        else {
            if (self.IsCompleted() == true) {
                BaoMenu.permissionEnable({
                    ActionKey: "ChecklistEvaluationDeleteIncomplete",
                    Enabled: false,
                    Context: tabPage.Context()
                });
            }
            Bao.Session.HasPermission("ChecklistEvaluationDeleteComplete", window.CheckwareApplicationId).subscribe(function (hasPermission) {
                if (hasPermission && self.DeleteDate() == null) {
                    BaoMenu.permissionEnable({
                        ActionKey: "ChecklistEvaluationDeleteIncomplete",
                        Enabled: self.HasEditPermissionForFolderStructure(),
                        Context: tabPage.Context()
                    });
                }
            });
            if (Bao.Session.HasPermission("ChecklistEvaluationDeleteComplete", window.CheckwareApplicationId)()) {
                BaoMenu.permissionEnable({
                    ActionKey: "ChecklistEvaluationDeleteIncomplete",
                    Enabled: self.HasEditPermissionForFolderStructure(),
                    Context: tabPage.Context()
                });
            }
        }
    };
    self.menuClick = function (action) {
        if (self.TabPage.IsActiveTab()) {
            switch (action.ActionKey()) {
                case "EvaluationSave":
                    self.Save();
                    break;
                case "ExportPdf":
                    self.ExportPdf();
                    break;
                case "ChecklistEvaluationDeleteIncomplete":
                    self.DeleteEvaluation();
                    break;
            }
        }
    };
    self.ExportPdf = function () {
        if (self.IsCompleted()) {
            self.JsManager.ExportPdf(self.EvaluationId());
        }
        else {
            if (self.ChecklistModel) {
                self.ChecklistModel.ExportPdf();
            }
        }
    };
    self.SaveAllowedCheck = function () {
        if (self.ChecklistModel != null && self.ChecklistModel.CompleteDate != null && self.ChecklistModel.CompleteDate() == null) {
            if ((self.ChecklistModel.InsertByUserId != null && self.ChecklistModel.InsertByUserId() == ko.unwrap(Bao.Session.User.UserId) || self.ChecklistModel.EvaluationSaveOtherUser != null && self.ChecklistModel.EvaluationSaveOtherUser() == true)  &&
                self.HasEditPermissionForFolderStructure() == true) {
                return true;
            }
        }
        return false;
    };
    self.EvaluationLoaded = function () {
        if (self.ChecklistModel != null) {
            self.ChecklistModel.DirtyFlag.subscribe(function () {
                tabPage.DirtyFlag(self.ChecklistModel.DirtyFlag());
            });
        }
    };
    self.destroy = function () {
        BaoMenu.unregisterEvent(self.menuClick);
        self = {};
    };
    self.BeforeClose = function (fn) {
        Bao.Utils.RemoveParam("mandatorid");
        if (tabPage.DirtyFlag() == true && self.SaveAllowedCheck() == true) {
            var questionDialog = new BaoDialog(Bao.Session.ApplicationName(), Bao.Session.GetMessage("msgSaveCheck"), "question");
            questionDialog.DialogResult.subscribe(function (result) {
                if (result === true) {
                    self.Save().done(function (data) {
                        self.destroy();
                        fn();
                    });
                }
                else if (result === false) {
                    if (tabPage.UrlData().IsNew == true) {
                        self.DeleteNewEvaluation();
                    }
                    self.destroy();
                    fn();
                }
            });
        }
        else {
            self.destroy();
            fn();
        }
    };
    self.DeleteEvaluation = function () {
        var yesNoDialog = new BaoDialog(Bao.Session.ApplicationName, _deleteEvaluationMessage, "yesno");
        yesNoDialog.DialogResult.subscribe(function (result) {
            if (result === true) {
                tabPage.IsLoading(true);
                return Bao.post("Checkware/Evaluation/DeleteEvaluation", JSON.stringify({
                    evaluationId: self.EvaluationId()
                }), function (result) {
                    if (result == true) {
                        tabPage.IsLoading(false);
                        tabPage.DirtyFlag(false);
                        Bao.raiseEvent("checklist-evaluation:refresh", null);
                        AppTabController.RemoveTab(tabPage);
                    }
                    else { }
                });
            }
        });
    };
    self.DeleteNewEvaluation = function () {
        return Bao.post("Checkware/Evaluation/DeleteNewEvaluation", JSON.stringify({
            evaluationId: self.ChecklistModel.EvaluationId()
        }), function () { });
    };
    self.init = function () {
        var checklistId = baoRouter.getRouteValue("folderStructureChecklistId", tabPage);
        var initValues = self.parseInitValues(baoRouter.getRouteValue("init*", tabPage));
        var isNew = Bao.Utils.String.IsNullOrEmpty(checklistId) == false;
        if (isNew == true) {
            self.UrlData({
                folderStructureChecklistId: checklistId,
                initParameters: initValues
            });
            self.Url("Checkware/Evaluation/New");
            tabPage.DirtyFlag(true);
            tabPage.UrlData().IsNew = true;
        }
        else {
            let mandatorId = Bao.Utils.ReadParam("mandatorid")?.Value;
            if (mandatorId) {
                mandatorId = mandatorId.split('/')[0];
            }
            else {
                mandatorId = null;
            }
            self.UrlData({
                mandatorId: mandatorId,
                evaluationId: baoRouter.getRouteValue("id", tabPage)
            });
            self.Url("Checkware/Evaluation/Open");
        }
    };
    self.parseInitValues = function (initValue) {
        var returnValue = [];
        if (initValue) {
            var splitParameters = initValue.split("/");
            if (splitParameters) {
                var i;
                for (i = 0; i < splitParameters.length; i++) {
                    var keyValueArr = splitParameters[i].split("=");
                    if (keyValueArr.length == 2) {
                        var hashObject = {
                            Key: keyValueArr[0],
                            Value: keyValueArr[1]
                        };
                        returnValue.push(hashObject);
                    }
                }
            }
            ;
        }
        return returnValue;
    };

    BaoMenu.registerEvent(self.menuClick);
}
export default EvaluationViewModel;